import styled from 'styled-components';

import { InfoSvg } from 'assets/img';
import { FormGridRowBase } from '../../AnketaForm.styles';
import { AnketaInputMask, AnketaFio, AreaInfo } from '../../../MainAnketa.styles';

export const FormGridRow = styled(FormGridRowBase)`
  grid-template-areas:
    '. fio fio fio fio ph ph is '
    '. . . bd bd pi pi . '
    '. spFio spFio spBd spBd spPh spPh spIs '
    '. . . spBi spBi spPi spPi . '
    '. rs . . . . . .';
`;

export const TrusteeFio = styled(AnketaFio)`
  grid-area: fio;
  margin-bottom: 0px;
`;

export const TrusteePhone = styled(AnketaInputMask)`
  grid-area: ph;
  margin-bottom: 0px;
`;

export const TrusteePhoneInfo = styled(AreaInfo)`
  display: flex;
  grid-area: ${(p) => (p.showPhoneInfo ? 'pi' : 'is')};
  width: ${(p) => (p.showPhoneInfo ? '100%' : '')};
  margin-top: 3px;

  span {
    min-height: 40px;
    font-size: 12px;
    margin-right: auto;
    color: var(--color-red-2);
  }
`;

export const SpouseFio = styled(TrusteeFio)`
  grid-area: spFio;
`;

export const SpousePhone = styled(TrusteePhone)`
  grid-area: spPh;
`;

export const SpousePhoneInfo = styled(TrusteePhoneInfo)`
  grid-area: ${(p) => (p.showPhoneInfo ? 'spPi' : 'spIs')};
`;

export const SpouseBirthday = styled(AnketaInputMask)`
  grid-area: spBd;
  margin-bottom: 0px;
`;

export const SpouseBirthdayInfo = styled(SpousePhoneInfo)`
  grid-area: ${(p) => (p.showBirthdayInfo ? 'spBi' : 'spIs')};
  width: ${(p) => (p.showBirthdayInfo ? '100%' : '')};
`;

export const StyledInfoSvg = styled(InfoSvg)`
  min-height: 14px;
  min-width: 14px;
  height: 14px;
  width: 14px;
  margin-left: 3px;
`;
